var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
import JobList from './Job/JobList'; // @ts-ignore
let Dashboard = class Dashboard extends Vue {
    constructor() {
        super();
        if (!this.$store.getters.isLoggedIn) {
            this.$router.push('/login');
        }
    }
    jobs = [];
    tab = '';
    Count = "";
    items = [
        { tab: 'Alle Aufträge insgesamt', amount: '', content: '5', color: 'green' },
        { tab: 'Alle überfällige Aufträge', amount: '', content: '4', color: 'red' },
        { tab: 'Neue Aufträge heute', amount: '', content: '0', color: 'green' },
        { tab: 'Neue Aufträge dieser Woche', amount: '', content: '1', color: 'green' },
        { tab: 'Fällige Aufträge dieser Woche', amount: '', content: '2', color: 'red' },
        { tab: 'Fällige Aufträge nächster Woche', amount: '', content: '3', color: 'red' },
    ];
    getovertime() {
        axios.get('/api/jobs/overtime').then((response) => {
            this.Count = response.data.data.datacount;
            this.items[0].amount = this.Count['Jobs'];
            this.items[4].amount = this.Count['nextWeekOvertime'];
            this.items[3].amount = this.Count['ThisWeek'];
            this.items[2].amount = this.Count['NewThisWeek'];
            this.items[1].amount = this.Count['Today'];
            this.items[5].amount = this.Count['Overtime'];
            this.items[0].content = 5;
        });
        return this.Count;
    }
    async watchJobs() {
        setTimeout(() => { this.getovertime(); }, 5000);
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getovertime();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
__decorate([
    Watch('Count', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Dashboard.prototype, "watchJobs", null);
Dashboard = __decorate([
    Component({
        name: 'Dashboard',
        components: { JobList }
    }),
    __metadata("design:paramtypes", [])
], Dashboard);
export default Dashboard;
